import axios from "axios";

/**
 * Axios client for Tactileo API.
 * The Authorization header is added if an access token is found in sessionStorage,
 * otherwise the client performs an anonymous request.
 */
const axiosApiClient = axios.create();

// Add request interceptor
axiosApiClient.interceptors.request.use(
  (config) => {
    const token = sessionStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error),
);

export default axiosApiClient;
